var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-view",class:{ 'modal-view--covers-appbar': _vm.coversAppbar }},[_c('div',{staticClass:"modal-mask",on:{"click":_vm.dismissModal}}),_c('div',{staticClass:"modal-container"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }